import { useQuery } from 'react-query';
import { queryConsultationDevis } from './useConsultationDevis.query';
import { UseConsultationDevisOptions } from './useConsultationDevis.types';
import { ConsultationDevis } from '../../../types/models/consultations/consultationDevis.types';
import { Company } from '../../../types/models/company/company.types';

export const CONSULTATION_DEVIS_QUERY_KEY = 'CONSULTATION_DEVIS';

export const useConsultationDevis = (
  consultationId: number,
  options?: UseConsultationDevisOptions
) => {
  return useQuery<(ConsultationDevis & Company)[], Error>(
    CONSULTATION_DEVIS_QUERY_KEY,
    () => queryConsultationDevis(consultationId),
    {
      retry: false,
      refetchOnWindowFocus: false,
      ...options,
    }
  );
};
